import {
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  DarkMode,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Stack,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { errorNotifier } from "../..";
import { useGetState } from "../../context/useGetState";
import LoginAlternative from "../signupSteps/LoginAlternative";
import { loginUser } from "../signupSteps/service";
import { Formik, Field } from "formik";
import { BASE_COLOR } from "../../constants";
import splash from "../../assets/splash.jpg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";

import {
  fireAuth,
  firebaseApp,
  firebaseAppAuth,
  firebaseCreateUserWithEmailAndPasswordProvider,
  firebaseGoogleProvider,
  firebaseRaw,
} from "../../service/firebase";
import {
  signInWithPopup,
  getAuth,
  createUserWithEmailAndPassword,
} from "@firebase/auth";
import { FcGoogle } from "react-icons/fc";

export const _CLEAR_ALL_SESSIONS = () => {
  sessionStorage.removeItem("#f8WEB#");
  sessionStorage.removeItem("acc_type");
  sessionStorage.removeItem("#f8WEB-firebase-success#");

  sessionStorage.removeItem("username");
  sessionStorage.removeItem("email");
  sessionStorage.removeItem("password");
  sessionStorage.removeItem("step_progress");
  sessionStorage.removeItem("totalStep");
};
function Signin() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const textColor = useColorModeValue("#fff", "#fff");
  const [loading, setLoading] = useState(false);
  const { dispatch } = useGetState();
  const [show, setShow] = useState(false);

  const inputStyle = {
    bg: "#fff",
    color: "#000",
    _placeholder: { color: "#000" },
  };

  const storeUserDetails = (details) => {
    dispatch({ userInfo: details?.user });
    sessionStorage.setItem("acc_type", details?.user?.account_type);
    sessionStorage.setItem("#f8WEB#", details?.token);
    sessionStorage.setItem("#f8WEB-firebase-success#", true);
  };

  const { auth } = firebaseApp;

  const submit = async (data) => {
    let { email, password } = data;

    const promise2 = loginUser({ login: email, password });
    Promise.all([promise2])
      .then(function (values) {
        const promiseResolved = values?.[0]?.data;

        storeUserDetails(promiseResolved);

        setLoading(false);

        window.location.href = "/dashboard";
      })
      .catch((e) => {
        setLoading(false);
        errorNotifier(e?.response?.data?.message);
      });
  };

  const loginToFirebase = (email) => {
    firebaseAppAuth
      .createUserWithEmailAndPassword(email, email)
      .then((userCredential) => {
        // User registered successfully
        const user = userCredential.user;
      })
      .catch((error) => {
        // Handle errors
      });
  };

  const signInWithGoogle = async () => {
    const auth = getAuth();
    const newUser = createUserWithEmailAndPassword(
      auth,
      "testuser@email.com",
      "password"
    );
    console.log("newUser:", newUser);
    return;
  };

  return (
    <Center
      backgroundImage={splash}
      h={{
        base: "100vh",
        sm: "100vh",
        md: "100vh",
        lg: "100vh",
        xl: "100vh",
        "2xl": "100vh",
      }}
    >
      <Grid justifyContent={"center"} alignItems={"center"}>
        <Box
          as="form"
          onSubmit={handleSubmit(submit)}
          backgroundColor={"#020B19"}
          // mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
          // mt={{
          //   base: "2em",
          //   sm: "2em",
          //   md: "2em",
          //   lg: "4em",
          //   xl: "4em",
          //   "2xl": "4em",
          // }}
          mt={16}
          h={{
            base: "85vh",
            sm: "85vh",
            md: "85vh",
            lg: "85vh",
            xl: "80vh",
            "2xl": "80vh",
          }}
          w={{
            base: "100vw",
            sm: "100vw",
            md: "60vw",
            lg: "60vw",
            xl: "60vw",
            "2xl": "60vw",
          }}
          borderWidth={1}
          borderColor={"#66666680"}
          borderRadius={{
            base: "0",
            sm: "0",
            md: "24px",
            lg: "24px",
            xl: "24px",
            "2xl": "24px",
          }}
          boxShadow="lg"
          p={{
            base: "25px",
            sm: "15px",
            md: "40px",
            lg: "60px",
            xl: "25px",
            "2xl": "15px",
          }}
        >
          <Stack direction={{ base: "column", md: "row" }}>
            {/* LHS */}
            <Flex
              pt={"4%"}
              color={"white"}
              flex={1}
              align={"center"}
              justify={"center"}
              ml={"5px"}
            >
              <Stack spacing={4} w={"full"} maxW={"md"}>
                <Box w={"268px"} h={"80px"}>
                  <Image
                    alt={"Login Image"}
                    marginBottom={"10px"}
                    width={"29px"}
                    src={arrow}
                    display={"none"}
                  />
                  <Heading
                    color={"#ffffff"}
                    paddingTop={1}
                    fontSize={"28px"}
                    fontWeight={500}
                    letterSpacing={0}
                    lineHeight={"normal"}
                  >
                    Welcome Back
                  </Heading>
                  <Flex gap={"5px"}>
                    <Text
                      fontWeight={400}
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      color={"white"}
                      fontSize={"15px"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Dont have an account?{" "}
                    </Text>

                    <Link to="/register">
                      <Text
                        color={"blue.500"}
                        fontWeight={400}
                        fontFamily={("Poppins-Regular", "Helvetica")}
                        fontSize={"15px"}
                        lineHeight={"normal"}
                        letterSpacing={0}
                        cursor="pointer"
                      >
                        Sign up
                      </Text>
                    </Link>
                  </Flex>
                </Box>
                <FormControl id="email">
                  <FormLabel
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    fontWeight={400}
                    fontSize={"14px"}
                    color={"#d5d5d5"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    Email address
                  </FormLabel>
                  <Input
                    {...register("email", { required: true })}
                    color={"white"}
                    borderColor={"#66666680"}
                    variant={"outline"}
                    borderWidth={1}
                    backgroundColor={"#020B19"}
                    type="email"
                  />
                  {errors.email && <span>This field is required</span>}
                </FormControl>

                <FormControl id="password">
                  <FormLabel
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    fontWeight={400}
                    fontSize={"14px"}
                    color={"#d5d5d5"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                  >
                    Password
                  </FormLabel>
                  <Input
                    backgroundColor={"#020B19"}
                    borderColor={"#66666680"}
                    borderWidth={1}
                    variant={"outline"}
                    {...register("password", {
                      required: true,
                      // pattern: /^[A-Za-z]+$/i,
                      minLength: 8,
                    })}
                    type={show ? "text" : "password"}
                  />

                  <Text
                    fontFamily={("Poppins-Regular", "Helvetica")}
                    fontWeight={400}
                    color={"#d5d5d5"}
                    lineHeight={"normal"}
                    letterSpacing={0}
                    fontSize={12.5}
                    mt={"5px"}
                  >
                    Use 8 or more characters with a mix of letters,numbers{" "}
                    <span dangerouslySetInnerHTML={{ __html: "&#038" }} />{" "}
                    symbols
                  </Text>
                </FormControl>

                <Stack spacing={6}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                    fontSize={"14px"}
                  >
                    <Checkbox
                      color={"#cbcbcb"}
                      onChange={(e) => setShow(!show)}
                    >
                      Show Password
                    </Checkbox>

                    <Link to="/forgot/password">
                      <Text

                        _hover={{ color: "#F9F6EE", cursor: "pointer" }}
                        color={"blue.500"}
                      >
                        Forgot password?
                      </Text>
                    </Link>
                  </Stack>
                  <Stack
                    align={{
                      base: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                      xl: "end",
                      "2xl": "end",
                    }}
                  >
                    <Button
                      borderRadius={24}
                      bg={"#0076FF"}
                      w={"150px"}
                      type="submit"
                      h={"50px"}
                      variant={"solid"}
                      _hover={{ background: "#7182f5" }}
                    >
                      {loading ? <Spinner /> : "Login"}
                    </Button>
                  </Stack>
                </Stack>

                <Stack display={"none"}>
                  <Text>Or Continue With</Text>
                  <Box>
                    <Button
                      onClick={signInWithGoogle}
                      borderRadius={24}
                      colorScheme={"#F6F6F6"}
                      w={"150px"}
                      h={"90px"}
                      variant={"outline"}
                      _hover={{
                        bg: "blue.600",
                      }}
                    >
                      <FcGoogle fontSize={"2em"} />
                    </Button>
                  </Box>
                </Stack>
              </Stack>
            </Flex>

            <Flex
              justify="center"
              align="center"
              display={["none", "none", "none", "flex"]}
            >
              <Image
                alt={"Login Image"}
                marginTop={6}
                height={"350px"}
                width={"250px"}
                objectFit={"cover"}
                src={logo}
              />
            </Flex>
          </Stack>
        </Box>

        {/* footer */}
        <Flex mr={5} ml={5} justify={"space-between"}>
          <Box>
            <Select fontSize={".9em"} color={"white"} w="auto">
              <option value="en"> English(Unites states)</option>
            </Select>
          </Box>
          <Box mt={2}>
            <Flex mr={10} justify={"space-evenly"}>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                color={"white"}
              >
                Help
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Privacy
              </Text>
              <Text
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={12}
                ml={"24px"}
                color={"white"}
              >
                Terms
              </Text>
            </Flex>
          </Box>
        </Flex>
        {/* footer */}
      </Grid>
    </Center>

  );
}

export default Signin;
